import { useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";

export default function MessageBoxModal({ receiverName, receiverId, cancelModal }) {
    const [content,setContent] = useState("");
    const [submitting,setSubmitting] = useState(false);
    const { user } = useAuthContext();
    


  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
    
    const CreateMessage = {receiverId,content};


    axios
      .post(`${ApiConnectionString}/api/message`, CreateMessage, {
        headers: { Authorization: `bearer ${user.token}` },
      })
      .then((response) => {
        setSubmitting(false);

        // Perform any necessary actions after successful update
      })
      .catch((error) => {
        console.error(error);
        // Handle any errors that occur during the update
      });
  };
  return (
    <div className="send-modal-overlay">
     
      <div className="send-modal">
        <form>
          <div className="send-modal-content">
            <h3>
              {receiverName} {receiverId}
            </h3>
            <label>Message:</label>
            <input
              type="text"
              placeholder="Type your message here"
              value={content}
              onChange={e => setContent(e.target.value)}
            />
          </div>
          <div className="send-modal-footer">
            <button className="confirm-button mx-3" onClick={handleSubmit}>Send</button>
            <button className="" onClick={cancelModal}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
